export default {
  getAccessToken() {
    return localStorage.getItem('auth0.access_token');
  }
};
